// Área GESTORES.
// Abas de gestor, esteira de aquecimento, demandas (status por conta+gestor,
// salvo em demandas_status) e diárias com modal (abrir/editar/salvar/excluir).
//
// Observação importante de compatibilidade:
//   No app legado a chave de demanda é `conta|gestor` (demKey usava r[0]|r[4]).
//   Mantemos esse mesmo comportamento; o valor do gestor é gravado na coluna
//   `offer` de demandas_status (a chave lógica conta|offer do banco recebe o
//   gestor). Assim o status segue casando exatamente como no original.
import { esc, svgDel, daysSince, hojeBR } from '../lib/format.js'
import { kpiHTML, drop } from './shared.js'
import { state, posicaoTopo } from '../store.js'
import { diariasRepo, demandasRepo, diariaValorColuna, DIARIA_COL } from '../data/repositories.js'
import { GESTOR_OPTS } from './contas.js'

// Constantes da esteira (idênticas ao legado).
const DEM_STATUS = ['A fazer', 'Em andamento', 'Feito']
const STAGE_ORDER = {
  Aquecer: 0,
  'Em engajamento': 1,
  'Em conversão white': 2,
  'Em conversão black': 3
}
const STAGE_LABEL = ['Engajamento', 'Conversão white', 'Conversão black']
const NOTE_FIELDS = [
  ['oferta', 'Oferta'],
  ['contas', 'Contas'],
  ['qtd', 'Quantidade de campanhas'],
  ['estrutura', 'Estrutura'],
  ['orcamento', 'Orçamento'],
  ['nicho', 'Nicho'],
  ['publico', 'Público']
]

// Estado local da área.
let gSub = 'contas',
  gCurrent = 'Gabriel',
  fDemTipo = '',
  fDemStatus = '',
  fDiaStatus = '',
  editingTask = null

let toast = () => {}
export function setToast(fn) {
  toast = fn
}

/* ============ Demandas (derivadas das contas) ============ */

// Etapa esperada em função dos dias desde a subida.
function expectedStage(days) {
  if (days == null) return 1
  if (days >= 3) return 3
  if (days >= 1) return 2
  return 1
}

// Chave lógica conta|gestor (igual ao legado: r[0]|r[4]).
function demKey(c) {
  return (c.conta || '') + '|' + (c.gestor || '')
}

// Status atual gravado no store (mapa demStatus) para a chave informada.
function statusDe(chave) {
  const d = state.demStatus[chave]
  return d ? d.status || 'A fazer' : 'A fazer'
}

// Calcula as demandas pendentes de um gestor a partir das contas.
function buildDemandas(gestor) {
  const out = []
  state.contas.forEach(c => {
    if ((c.status || '').trim().toUpperCase() === 'CAIU') return
    const conta = (c.conta || '').trim()
    if (!conta) return
    if (gestor && (c.gestor || '').trim() !== gestor) return
    const days = daysSince(c.data)
    const cur = STAGE_ORDER[(c.situacao || '').trim()]
    const curIdx = cur == null ? 0 : cur
    const exp = expectedStage(days)
    if (curIdx >= exp) return
    const acao = 'Jogar ' + STAGE_LABEL[exp - 1]
    const key = demKey(c)
    const st = statusDe(key)
    out.push({
      conta,
      gestor: (c.gestor || '').trim(),
      data: c.data || '',
      days,
      etapaAtual: (c.situacao || '').trim() || '—',
      acao,
      key,
      st
    })
  })
  return out
}

/* ============ Render ============ */

export function renderGestores() {
  // barra de gestores
  const bar = document.getElementById('gestBar')
  bar.innerHTML = GESTOR_OPTS.map(g => {
    const pend = buildDemandas(g).filter(d => d.st !== 'Feito').length
    const ini = g.charAt(0).toUpperCase()
    return (
      '<div class="gtab' +
      (g === gCurrent ? ' active' : '') +
      '" data-g="' +
      esc(g) +
      '"><span class="av">' +
      ini +
      '</span>' +
      esc(g) +
      (pend ? '<span class="gn">' + pend + '</span>' : '') +
      '</div>'
    )
  }).join('')
  bar.querySelectorAll('.gtab').forEach(t => {
    t.onclick = () => {
      gCurrent = t.dataset.g
      renderGestores()
    }
  })

  document.querySelectorAll('#area-gestores .subtab').forEach(t => {
    t.classList.toggle('active', t.dataset.sub === gSub)
  })
  document.getElementById('sub-contas').classList.toggle('hidden', gSub !== 'contas')
  document.getElementById('sub-diarias').classList.toggle('hidden', gSub !== 'diarias')
  if (gSub === 'contas') renderDemandas()
  else renderDiarias()
}

function renderDemandas() {
  const all = buildDemandas(gCurrent)
  const tpC = {},
    stC = {}
  all.forEach(d => {
    tpC[d.acao] = (tpC[d.acao] || 0) + 1
    stC[d.st] = (stC[d.st] || 0) + 1
  })
  const acaoOpts = ['Jogar Engajamento', 'Jogar Conversão white', 'Jogar Conversão black']
  const pend = all.filter(d => d.st !== 'Feito').length
  document.getElementById('demKpis').innerHTML =
    kpiHTML('Demandas abertas', all.length, '', '') +
    kpiHTML('Pendentes', pend, '', pend ? 'a' : 'g') +
    kpiHTML('Feitas', all.length - pend, '', 'g')
  drop('demTipoDrop', 'Todas as demandas', fDemTipo, tpC, acaoOpts, v => {
    fDemTipo = v
    renderDemandas()
  })
  drop('demStatusDrop', 'Todos os andamentos', fDemStatus, stC, DEM_STATUS, v => {
    fDemStatus = v
    renderDemandas()
  })
  const list = all.filter(
    d => (!fDemTipo || d.acao === fDemTipo) && (!fDemStatus || d.st === fDemStatus)
  )
  const body = document.getElementById('demBody')
  body.innerHTML = ''
  if (!list.length) {
    body.innerHTML =
      '<tr><td colspan="6" style="padding:30px;text-align:center;color:var(--dim)">Nenhuma demanda pendente para ' +
      esc(gCurrent) +
      ' 🎉</td></tr>'
  }
  list
    .sort((a, b) => (b.days || 0) - (a.days || 0))
    .forEach(d => {
      const tr = document.createElement('tr')
      const overdue = d.days != null && d.days >= 1
      tr.innerHTML =
        '<td><span class="cell" style="color:var(--txt);font-weight:600">' +
        esc(d.conta) +
        '</span></td>' +
        '<td><span class="cell" style="color:var(--mut)">' +
        esc(d.data || '—') +
        '</span></td>' +
        '<td><span class="daycount" style="padding-left:7px;color:' +
        (overdue ? 'var(--amber)' : 'var(--mut)') +
        '">' +
        (d.days == null ? '—' : d.days + 'd') +
        '</span></td>' +
        '<td><span class="cell" style="color:var(--mut)">' +
        esc(d.etapaAtual) +
        '</span></td>' +
        '<td><span class="due">' +
        esc(d.acao) +
        '</span></td>' +
        '<td class="cellst"></td>'
      const td = tr.querySelector('.cellst')
      const sel = document.createElement('select')
      sel.className = 'cell'
      DEM_STATUS.forEach(o => {
        const op = document.createElement('option')
        op.value = o
        op.textContent = o
        if (d.st === o) op.selected = true
        sel.appendChild(op)
      })
      sel.onchange = async () => {
        // chave conta|gestor → grava gestor na coluna `offer`
        const [conta, gestorKey] = d.key.split('|')
        // atualização otimista do store
        state.demStatus[d.key] = {
          ...(state.demStatus[d.key] || {}),
          conta,
          offer: gestorKey,
          status: sel.value
        }
        renderGestores()
        try {
          const salvo = await demandasRepo.upsertStatus(conta, gestorKey, sel.value)
          state.demStatus[d.key] = salvo
        } catch (e) {
          toast('Erro ao salvar', true)
        }
      }
      td.appendChild(sel)
      body.appendChild(tr)
    })
  document.getElementById('demCount').textContent =
    list.length + (list.length !== all.length ? ' / ' + all.length : '') + ' demandas'
}

function renderDiarias() {
  const mine = state.diarias.filter(t => (t.gestor || '') === gCurrent)
  const stC = {}
  mine.forEach(t => {
    const s = t.status || 'A fazer'
    stC[s] = (stC[s] || 0) + 1
  })
  drop('diaStatusDrop', 'Todos os andamentos', fDiaStatus, stC, DEM_STATUS, v => {
    fDiaStatus = v
    renderDiarias()
  })
  const list = mine.filter(t => !fDiaStatus || (t.status || 'A fazer') === fDiaStatus)
  const body = document.getElementById('diaBody')
  body.innerHTML = ''
  if (!list.length) {
    body.innerHTML =
      '<tr><td colspan="4" style="padding:28px;text-align:center;color:var(--dim)">Nenhuma tarefa para ' +
      esc(gCurrent) +
      '. Clique em “Nova tarefa”.</td></tr>'
  }
  list.forEach(t => {
    const tr = document.createElement('tr')
    const titulo = t.titulo || '(sem título — clique para preencher)'
    tr.innerHTML =
      '<td><span class="cell" style="color:var(--mut)">' +
      esc(t.data || '') +
      '</span></td>' +
      '<td><div class="tasklink"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><path d="M14 2v6h6M8 13h8M8 17h5"/></svg><span>' +
      esc(titulo) +
      '</span></div></td>' +
      '<td class="cellst"></td><td class="celldel"></td>'
    tr.querySelector('.tasklink').onclick = () => openTask(t)
    const td = tr.querySelector('.cellst')
    const sel = document.createElement('select')
    sel.className = 'cell'
    DEM_STATUS.forEach(o => {
      const op = document.createElement('option')
      op.value = o
      op.textContent = o
      if ((t.status || 'A fazer') === o) op.selected = true
      sel.appendChild(op)
    })
    sel.onchange = async () => {
      t.status = sel.value
      renderGestores()
      try {
        if (t.id) await diariasRepo.update(t.id, { status: sel.value })
      } catch (e) {
        toast('Erro ao salvar', true)
      }
    }
    td.appendChild(sel)
    const tdd = tr.querySelector('.celldel')
    const del = document.createElement('span')
    del.className = 'del'
    del.innerHTML = svgDel
    del.onclick = async () => {
      const i = state.diarias.indexOf(t)
      if (i === -1) return
      state.diarias.splice(i, 1)
      renderDiarias()
      try {
        if (t.id) await diariasRepo.remove(t.id)
      } catch (e) {
        state.diarias.splice(i, 0, t) // rollback: o banco não confirmou
        renderDiarias()
        toast('Erro ao excluir', true)
      }
    }
    tdd.appendChild(del)
    body.appendChild(tr)
  })
  document.getElementById('diaCount').textContent = list.length + ' tarefas'
}

/* ============ Modal de tarefa ============ */

function openTask(t) {
  if (!t) return
  editingTask = t
  document.getElementById('taskModalTitle').textContent = 'Tarefa — ' + (t.gestor || '')
  const body = document.getElementById('taskModalBody')
  let h =
    '<div class="mfield"><label>Título da tarefa</label><input id="tf-titulo" value="' +
    esc(t.titulo || '') +
    '" placeholder="Ex.: Subir campanhas OF-95"></div>'
  NOTE_FIELDS.forEach(([k, lbl]) => {
    h +=
      '<div class="mfield"><label>' +
      lbl +
      '</label><input id="tf-' +
      k +
      '" value="' +
      esc(t[k] || '') +
      '" placeholder="—"></div>'
  })
  h +=
    '<div class="mfield"><label>Anotações livres</label><textarea id="tf-livre" placeholder="Escreva o que quiser...">' +
    esc(t.livre || '') +
    '</textarea></div>'
  body.innerHTML = h

  // Salva todos os campos do modal no Supabase e mostra "✓ salvo".
  let timer = null
  const save1 = () => {
    t.titulo = document.getElementById('tf-titulo').value
    NOTE_FIELDS.forEach(([k]) => {
      t[k] = document.getElementById('tf-' + k).value
    })
    t.livre = document.getElementById('tf-livre').value
    clearTimeout(timer)
    timer = setTimeout(async () => {
      try {
        if (t.id) {
          const patch = {
            titulo: t.titulo,
            livre: t.livre
          }
          NOTE_FIELDS.forEach(([k]) => {
            patch[DIARIA_COL[k]] = diariaValorColuna(k, t[k])
          })
          await diariasRepo.update(t.id, patch)
        }
      } catch (e) {
        toast('Erro ao salvar', true)
      }
    }, 400)
    const sv = document.getElementById('taskSaved')
    sv.textContent = '✓ salvo'
    setTimeout(() => (sv.textContent = ''), 1500)
  }
  body.querySelectorAll('input,textarea').forEach(el => (el.oninput = save1))
  document.getElementById('taskModal').classList.add('open')
}

function closeTask() {
  document.getElementById('taskModal').classList.remove('open')
  editingTask = null
  renderDiarias()
}

/* ============ Ligações (uma vez no boot) ============ */

export function ligarGestores() {
  document.querySelectorAll('#area-gestores .subtab').forEach(t => {
    t.onclick = () => {
      gSub = t.dataset.sub
      renderGestores()
    }
  })
  document.getElementById('addDiaria').onclick = async () => {
    const nova = {
      id: crypto.randomUUID(),
      gestor: gCurrent,
      data: hojeBR(),
      titulo: '',
      status: 'A fazer',
      oferta: '',
      contas: '',
      qtd: '',
      estrutura: '',
      orcamento: '',
      nicho: '',
      publico: '',
      livre: '',
      posicao: posicaoTopo(state.diarias)
    }
    state.diarias.unshift(nova)
    renderDiarias()
    try {
      const salva = await diariasRepo.insert(nova)
      nova.id = salva.id
      openTask(nova)
    } catch (e) {
      const i = state.diarias.indexOf(nova) // rollback: insert falhou
      if (i !== -1) state.diarias.splice(i, 1)
      renderDiarias()
      toast('Erro ao criar tarefa', true)
    }
  }
  document.getElementById('taskClose').onclick = closeTask
  document.getElementById('taskDone').onclick = closeTask
  document.getElementById('taskModal').onclick = e => {
    if (e.target.id === 'taskModal') closeTask()
  }
}

// Conta de demandas pendentes de TODOS os gestores (sidebar).
export function totalDemandasPendentes() {
  return buildDemandas().filter(d => d.st !== 'Feito').length
}

export function onExternalChange() {
  renderGestores()
}
